<template>
    <v-card class="pa-4">
        <v-container no-gutters class="pa-0">
            <v-row>
                <v-col cols="auto">
                    <span>{{ record.dateTimeString }}</span>
                    <span v-if="record.exceptions?.length"><br />({{ $t('mit_ausnahmen') }})</span>
                    <!-- <IconBtn icon-cls="download" icon-color="grey" :href="getScheduleIcsUrl()" target="_blank" /> -->
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <IconBtn icon-cls="pencil" icon-color="grey" @click="editRecord" />
                    <IconBtn icon-cls="copy" icon-color="grey" @click="dupeRecord" />
                    <IconBtn icon-cls="trash" icon-color="grey" @click="deleteRecord" />
                </v-col>
            </v-row>
        </v-container>
        <v-divider class="my-1" />
        <table class="schedule-infos">
            <tr v-if="record.isRecurring">
                <td colspan="2">
                    {{ getRecurringString() }}
                </td>
            </tr>
            <tr v-if="record.location_title">
                <td class="info-label">{{ $t('event_location') }}:</td>
                <td>{{ record.location_title }}, {{ record.location_zip }} {{ record.location_city }}</td>
            </tr>
            <tr v-if="record.online_event_url">
                <td class="info-label">{{ $t('label_event_online_url') }}:</td>
                <td>{{ record.online_event_url }}</td>
            </tr>
            <tr v-if="record.description">
                <td class="info-label">{{ $t('zusatzinfos') }}:</td>
                <td>{{ record.description }}</td>
            </tr>
            <tr v-if="record.schedule_status_value">
                <td class="info-label">{{ $t('schedule_status') }}:</td>
                <td>{{ record.schedule_status_value }}</td>
            </tr>
            <tr v-if="record.target_audience_id">
                <td class="info-label">{{ $t('label_schedule_target_audience_id') }}:</td>
                <td>{{ record.target_audience }}</td>
            </tr>
            <tr v-if="record.typical_age_range">
                <td class="info-label">{{ $t('label_schedule_typical_age_range') }}:</td>
                <td>{{ record.typical_age_range }}</td>
            </tr>
            <tr v-if="record.presales">
                <td class="info-label">{{ $t('label_schedule_presale') }}:</td>
                <td>{{ record.presales }}</td>
            </tr>
            <tr v-if="record.presales_link">
                <td class="info-label"></td>
                <td>{{ record.presales_link }}</td>
            </tr>
            <tr v-if="record.ticketprices">
                <td class="info-label">{{ $t('label_schedule_ticketprices') }}:</td>
                <td>{{ record.ticketprices }}</td>
            </tr>
            <tr v-if="record.accessibility">
                <td class="info-label">{{ $t('label_schedule_accessibility') }}:</td>
                <td>{{ record.accessibility }}</td>
            </tr>
            <tr v-if="record.tags && record.tags.length > 0">
                <td class="info-label">{{ $t('ereignis_merkmal_rahmen') }}:</td>
                <td>
                    <v-chip v-for="tag in record.tags" :key="tag" small color="primary" class="ma-1">
                        {{ tag }}
                    </v-chip>
                </td>
            </tr>
            <tr v-if="record.is_sold_out">
                <td class="info-label">&nbsp;</td>
                <td>
                    <v-chip small color="primary" class="ma-1">
                        {{ $t('sold_out') }}
                    </v-chip>
                </td>
            </tr>
        </table>
    </v-card>
</template>

<script>
import { Schedule } from '@/models/Schedule';
import { Event } from '@/models/Event';
import { apiUrl } from '@/helpers/globals';

export default {
    name: 'ScheduleCard',

    props: {
        event: Event,
        record: Schedule,
    },

    created() {
        this.Schedule = Schedule;
    },

    methods: {
        getScheduleIcsUrl() {
            return apiUrl('Schedule/ics', { id: this.record.getId() });
        },

        editRecord() {
            this.$emit('edit', this.record);
        },

        dupeRecord() {
            this.$emit('duplicate', this.record);
        },

        deleteRecord() {
            this.$emit('delete', this.record);
        },

        getRecurringString() {
            let every = '';
            switch (this.record.recurring_type) {
                case Schedule.RECURRING_TYPE_WEEKLY:
                    every = 'jede';
                    break;
                case Schedule.RECURRING_TYPE_YEARLY:
                    every = 'jedes';
                    break;
                default:
                    every = 'jeden';
                    break;
            }
            return this.$tc('recurring_schedule_text', this.record.recur_every_n, {
                every: this.$t(every),
                recur_every_n: this.record.recur_every_n,
                recurring_type: this.$t(this.record.recurring_type),
                recurrence_config: this.getRecurrenceConfigString(),
            });
        },

        getRecurrenceConfigString() {
            switch (this.record.recurring_type) {
                case Schedule.RECURRING_TYPE_DAILY:
                    return '';
                case Schedule.RECURRING_TYPE_MONTHLY:
                    return this.$t('every_nr_month', { nr: this.record.start_date.formatIf('D') });
                case Schedule.RECURRING_TYPE_WEEKLY: {
                    const weekdays = this.record.recurrence_config?.weekdays ?? [];
                    if (!(weekdays instanceof Array)) {
                        return '';
                    }
                    return weekdays
                        .map((weekday) => {
                            switch (parseInt(weekday, 10)) {
                                case 1:
                                    return this.$t('monday_short');
                                case 2:
                                    return this.$t('tuesday_short');
                                case 3:
                                    return this.$t('wednesday_short');
                                case 4:
                                    return this.$t('thursday_short');
                                case 5:
                                    return this.$t('friday_short');
                                case 6:
                                    return this.$t('saturday_short');
                                case 7:
                                    return this.$t('sunday_short');
                                default:
                                    return 'fail';
                            }
                        })
                        .filter((el) => el)
                        .join(', ');
                }
                case Schedule.RECURRING_TYPE_YEARLY:
                    return this.$t('every_date_year', { date: this.record.start_date.formatIf('D. MMMM') });
                default:
                    return '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.schedule-infos {
    .info-label {
        width: 230px;
    }
}
</style>
